@use '../../../../utils.scss';
@use '../../../../base-variables.scss';

.Divider {
	width: 100%;
	background-color: utils.color('standby-blue-gray');
	padding: 0;
	margin: 4px 0;
	height: 1px;
}
.Option {
	width: 100%;
	color: utils.color('midnight');
	padding: 10px 0;
	border-left: 3px solid transparent;
	display: flex;
	align-items: center;
	cursor: pointer;
	.Container{
		color:inherit;
		&:hover{
			color:inherit; 
		}
	}
	&.HasNoIcon {
		padding-left: 10px;
	}
	&.Active {
		color: utils.color('nebula');
		border-left: 3px solid utils.color('nebula');
		// padding-left: 19px;
	}
    &.NoActiveBorder {
        border-left: 3px solid rgba(0, 0, 0, 0);;
    }
	&.Indented {
		.Container {
			font-weight: normal;
			margin-left: 16px;
		}
	}
	&:hover {
		border-left: 3px solid utils.color('nebula');
		color: utils.color('nebula');
		background-color: #ecf6ff;
	}
	&.Danger {
		color: #af0b2b;
		&:hover {
			border-left: 3px solid #af0b2b;
			color: #af0b2b;
			background-color: #fdeef1;
		}
	}
	&.Faded {
		color: base-variables.$icon-inactive-color;
		&.Active {
			color: utils.color('nebula');
		}
		&:hover {
			color: utils.color('nebula');
		}
	}
	&.Disabled,
	&.Header {
		color: base-variables.$icon-inactive-color;
		cursor: default;
		&:hover {
			border-left: 3px solid transparent;
			color: base-variables.$icon-inactive-color;
			background-color: inherit;
		}
	}
	&.Header {
		color: utils.color('midnight');
		font-weight: bold;
		&:hover {
			color: utils.color('midnight');
		}
	}
	& > svg {
		&.OptionIcon {
			margin-left: 0px !important;
			margin-right: 8px;
		}
	}
	& span {
		color: inherit;
	}

	.Overflow{
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
}

.IconContainer {
	display: flex;
	align-items: center;
	justify-content: center;
	// border: 1px solid green;
	width: 62px;
	padding-right: 22px;
	padding-left: 20px;
	margin: 0;
	svg {
		height: 20px;
		width: 20px;
	}
}
.ButtonAtEndOption {
	padding-left: 10px;
	padding-right: 10px;
	width: 42px;
}
.GhostButtonContainer{
	display:flex; 
	justify-content: space-between;
}

.Container{
	display: flex; 
	justify-content: space-between;
	min-width:0; 
	flex-grow: 100;
	width: calc(100% - 53px);
	align-items: center;
}
.RightSideDiv {
padding-right: 10px;
}